import React from 'react'
import styled from 'styled-components'

const IMG = props => <img {...props} />
const Loading = styled(IMG)`
  width: 80px;
  height: 80px;
`

export default () => <Loading src="https://static.olx.com.br/accounts/loading.gif" />
